module.exports = __webpack_public_path__ + "img/wallet.cd4cc556.svg";